// extracted by mini-css-extract-plugin
export default {"overlay":"SetupModal_overlay__R07aN","modal":"SetupModal_modal__+RAFX","content":"SetupModal_content__XVIEK","closeButton":"SetupModal_closeButton__HczYP"};